/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';

const DEFAULT_CLASSES = {
    root: 'Select__SelectOption',
    selected: 'Select__SelectOption--selected',
};

const SelectOption = React.forwardRef(
    ({ children, value, classes, ...props }, ref) => (
        <MenuItem
            value={value}
            classes={{ ...DEFAULT_CLASSES, ...classes }}
            {...props}
            ref={ref}
        >
            {children}
        </MenuItem>
    )
);

SelectOption.muiName = MenuItem.muiName;

export default SelectOption;
